var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaywerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 1.7619L4.02381 3.5L2.2619 1.7619L4.02381 0L5.7619 1.7619ZM8 4L6.26191 5.7619L4.52381 4L6.26191 2.2619L8 4ZM3.52381 4L1.7619 5.7619L0 4L1.7619 2.2619L3.52381 4ZM5.7619 6.2619L4.02381 8L2.2619 6.2619L4.02381 4.5L5.7619 6.2619Z",
    fill: "#26323E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaywerIcon);
export default __webpack_public_path__ + "static/media/laywer_icon.c2bbeeccfdf7f2690870870b4b1135bf.svg";
export { ForwardRef as ReactComponent };